import React, { useState } from 'react'

const Search = React.createContext('')

export function SearchContext(props) {
    const [state, reducer] = useState('')
    return <Search.Provider value={[state, reducer]}>{props.children}</Search.Provider>
}

export default Search